import { render, staticRenderFns } from "./exclusion.vue?vue&type=template&id=ab49b450&scoped=true"
import script from "./exclusion.vue?vue&type=script&lang=js"
export * from "./exclusion.vue?vue&type=script&lang=js"
import style0 from "./exclusion.vue?vue&type=style&index=0&id=ab49b450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab49b450",
  null
  
)

export default component.exports